import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box, 
} from "@mui/material";
import React from "react";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


const PrimaryTable = ({ columns, data, translation }) => {
  return (
    <TableContainer>
      <Table sx={{ borderRadius: "8px", overflow: "hidden" }} stickyHeader>
        <TableHead>
          <TableRow>
            {columns?.map((column, i) => (
              <TableCell align={column?.align} key={i}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          { Array.isArray(data) && data.length ?
            data?.map((item, i) => {
              return (
                <TableRow hover key={`table_row${i}`}>
                  {columns.map((column, i) => {
                    return (
                      <TableCell align={column?.align} key={`table_col${i}`}>
                        {column.type === 'NameWithPhone' ? (
                          <Box display={"flex"} flexDirection={"column"}>
                            <Typography variant="subtitle2" fontWeight={500}>
                              {item[column.accessor]}
                            </Typography>
                            <Typography fontSize={12} color="secondary.light" sx={(theme) => ({direction: `${theme.direction} !important`})} >{`${item['DialCode']}-${item['Mobile']}`}</Typography>
                          </Box>
                        ) : column.type === 'Date' ? (
                          new Date(item[column.accessor]).toLocaleString("default", {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                        ) : column.type === 'Translation' ? (
                          translation[item[column.accessor]]
                        ) : column.type === 'Status' ? (
                            <PrimaryIcon
                              icon={item[column.accessor] === 'Active' ? CheckCircleOutlineIcon : item[column.accessor] === 'Inactive' ? HighlightOffOutlinedIcon : ErrorOutlineIcon}
                              color={item[column.accessor] === 'Active' ? 'success' : item[column.accessor] === 'Inactive' ? 'error' : 'secondary'}
                              height="14px"
                              width="14px"
                            />
                        ) : (
                          item[column.accessor]
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : 
            <TableRow>
              <TableCell align="center" colSpan={columns.length}>
                <Typography variant="body1" py={2}>
                  {translation?.NoDataFound}
                </Typography>
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PrimaryTable;
